import '../styles/AiAcknowledgmentModal.css';

function AiAcknowledgmentModal({ onAcknowledge }) {
    return (
        <div className="ai-ack-modal-overlay">
            <div className="ai-ack-modal">
                <div className="ai-ack-icon">&#9888;</div>
                <h2>AI-Generated Content Notice</h2>
                <p>
                    This application uses artificial intelligence to extract information
                    from medical documents and generate clinical content including
                    History of Present Illness (HPI) and diagnosis summaries.
                </p>
                <p>
                    <strong>
                        AI-generated results may contain errors or omissions. You are
                        responsible for reviewing and verifying the accuracy of all
                        information before use.
                    </strong>
                </p>
                <button className="ai-ack-button" onClick={onAcknowledge}>
                    I Understand
                </button>
            </div>
        </div>
    );
}

export default AiAcknowledgmentModal;
